$(document).ready((function(){
    if ( $('#articles-tab').hasClass('active') ) {
        $("#articles-tab").click();
    }else{
        $("#product-tab").click();
    }
}));
//# sourceMappingURL=featureCardsPLP.js.map

// Script to retain filters on PLP
$(document).ready(function() {
    $('.refinement-option-button, .sidebarClearButton').on('click', function(event) {
        setTimeout(function() {
            var redirectHref = event.currentTarget.dataset.href.split('?')[1];
            var currentUrl = window.location.href.split('?')[0];
            var filterRetainingUrl = currentUrl + '?' +redirectHref;
            history.pushState(null, '', filterRetainingUrl);
        }, 100);
    });
});
